//这里是 配件管理 模块的路由文件

const basePath = "/admin/machineParts/"
export default [
    {
        path: `${basePath}list`,
        name: 'MachinePartsList',
        component: r => require.ensure([], () => r(require('@/views/machineParts/MachinePartsList')), 'MachineParts')
    }
]
